"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftStatus = exports.NftAvailable = exports.NftAccess = exports.PRICE_UNITS = exports.MAX_STATS_COUNT = exports.MAX_PROPERTIES_COUNT = void 0;
/**
 * Max NFT properties.
 */
exports.MAX_PROPERTIES_COUNT = 25;
/**
 * Max NFT stats.
 */
exports.MAX_STATS_COUNT = 25;
exports.PRICE_UNITS = ['Mi', 'Gi'];
/**
 * NFT Access options.
 */
var NftAccess;
(function (NftAccess) {
    NftAccess[NftAccess["OPEN"] = 0] = "OPEN";
    NftAccess[NftAccess["MEMBERS"] = 1] = "MEMBERS";
})(NftAccess = exports.NftAccess || (exports.NftAccess = {}));
/**
 * NFT Available options.
 */
var NftAvailable;
(function (NftAvailable) {
    NftAvailable[NftAvailable["UNAVAILABLE"] = 0] = "UNAVAILABLE";
    NftAvailable[NftAvailable["SALE"] = 1] = "SALE";
    NftAvailable[NftAvailable["AUCTION"] = 2] = "AUCTION";
    NftAvailable[NftAvailable["AUCTION_AND_SALE"] = 3] = "AUCTION_AND_SALE";
})(NftAvailable = exports.NftAvailable || (exports.NftAvailable = {}));
/**
 * NFT status.
 */
var NftStatus;
(function (NftStatus) {
    NftStatus["PRE_MINTED"] = "pre_minted";
    NftStatus["MINTED"] = "minted";
    NftStatus["WITHDRAWN"] = "withdrawn";
    NftStatus["STAKED"] = "staked";
})(NftStatus = exports.NftStatus || (exports.NftStatus = {}));
